import Menu from "./components/Menu";

function Header(props) {
  return (
    <div className="header">
      <Menu />
    </div>
  );
}

export default Header;
